const initialState = {
  studentType: '',
  instructor: '',
  course: '',
  gradeLevel: '',
};

export default initialState;
